define('modules/domain_listing/views/empty_view',['require','exports','module','base/itemview','i18n','ldsh!../templates/empty_view'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      i18n = require("i18n");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/empty_view"),
    initialize: function() {
      this.i18n = {
        configLink: i18n.t("domainListing.configLink"),
        contactUs: i18n.t("domainListing.contactUs")
      };
    },
    helpers: function() {
      return {
        configLink: this.i18n.configLink,
        contactUs: this.i18n.contactUs
      };
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

});

